module.exports = __webpack_public_path__ + "media/categories/2021-f8c705bc.svg";